import axios from "axios";
import { api } from "./api_client";

export default async function subscribe(email: string, signal?: AbortSignal) {
  try {
    const response = await api.post(`/subscriptions`, {
      email,
      signal,
    });
    return response.data.path;
  } catch (error) {
    if (axios.isCancel(error)) {
      console.log("Request aborted");
    } else {
      console.error("Error fetching data:", error);
    }

    throw error;
  }
}
